import Image from "next/legacy/image";

import * as S from "./MktLandingPageBenefitsOrganism.style";
import discount from "public/images/landing/benefits/discount.png";
import prestudy from "public/images/landing/benefits/prestudy.png";

export default function MktLandingPageBenefitsOrganism() {
  return (
    <S.Wrapper>
      <S.Title>
        빠르게 합류할 수록
        <br />
        혜택과 성장의 폭은 넓어집니다.
      </S.Title>
      <S.Benefits>
        <article>
          <S.BenefitNumber>얼리버드 혜택 1</S.BenefitNumber>
          <S.BenefitTitle>1기 론칭 기념 130만 원 할인</S.BenefitTitle>
          <S.DiscountImageWrapper>
            <Image
              src={discount}
              layout="fill"
              objectFit="cover"
              objectPosition="center"
              quality={100}
              priority={true}
              alt={"discount"}
            />
          </S.DiscountImageWrapper>
        </article>
        <article>
          <S.BenefitNumber>얼리버드 혜택 2</S.BenefitNumber>
          <S.BenefitTitle>사전 스터디 참여 기회</S.BenefitTitle>
          <S.PrestudyImageWrapper>
            <Image
              src={prestudy}
              layout="fill"
              objectFit="cover"
              objectPosition="center"
              quality={100}
              priority={true}
              alt={"prestudy"}
            />
          </S.PrestudyImageWrapper>
          <S.PrestudyDesc>
            본격적인 교육 시작 전, 12주를 함께 할 팀원들과 사전 스터디에 <br />
            참여해보세요. 더 빨리 합류할 수록 충분한 준비 기간을 <br />
            확보할 수 있습니다.
          </S.PrestudyDesc>
        </article>
      </S.Benefits>
    </S.Wrapper>
  );
}
